import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { class: "d-flex justify-space-between" }

import TimepickerSmall from "@/components/inputs/TimepickerSmall.vue";
import {computed, reactive, ref, watch} from "vue";
import {Feedback, StatePermission, Task} from "@/types/Order";
import UniversalPopup from "@/components/misc/UniversalPopup.vue";
import CloseFeedbackForm from "@/components/forms/CloseFeedbackForm.vue";
import {getCurrentUser, useGlobalSetting} from "@/lib/utils";

/*
* TODO: duration required
* */

interface Props {
  readonly?: boolean;
  onChange?: () => void;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FeedbackForm',
  props: /*@__PURE__*/_mergeModels({
    readonly: { type: Boolean, default: false },
    onChange: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props;


const globalSettings = useGlobalSetting();

const record = _useModel<Task>(__props, "modelValue");

const old_feedback = JSON.parse(JSON.stringify(record.value?.feedbacks));

const closeFeedbackPopup = ref<typeof UniversalPopup | null>(null);

const panels = reactive<Feedback[]>(record.value?.feedbacks);//record.value?.tasks[props.index].feedbacks

const getNexId = (): number => {
  if (record.value?.feedbacks.length != 0 && record.value?.feedbacks[record.value.feedbacks.length - 1].id != undefined) {
    return record.value?.feedbacks[record.value.feedbacks.length - 1].id + 1
  }
  return 1;
}

const addFeedback = () => {
  panels.push({
    id: getNexId(),
    task_id: record.value.id,
    author: getCurrentUser(),
    text: "",
    duration: "",
    //timestamp: new Date().toISOString().substring(0, 16),
    created_at: new Date().toISOString().substring(0, 16),
    _isNew: true
  });
};

function isDisabled(panel: Feedback): boolean {
  return old_feedback?.some(feedback => feedback.id === panel.id) ?? false;
}

const isReadonly = computed(() => {
  if (props.readonly) {
    return true;
  }
  return record.value?.state == 1;
});

const removeFeedback = (index: number) => {
  panels.splice(index, 1);
};

function openPopup() {
  closeFeedbackPopup.value?.open(
      CloseFeedbackForm,
      {
        onClose: closeFeedbackPopup.value.close,
        modelValue: record,
        /*onSubmit: (value: Aufgabe) => {
          Object.assign(record, value);
        }*/
      },
      {
        dialogTitle: "Auftrag Beenden",
        maxWidth: 500
      }
  );
}

watch(() => record, (newVal) => {
  props.onChange?.();
  useGlobalSetting().hasChanged = true;
}, {deep: true});


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", null, [
          (!_ctx.readonly)
            ? (_openBlock(), _createBlock(_component_v_btn, {
                key: 0,
                onClick: addFeedback
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_icon, { start: "" }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                      _createTextVNode("mdi-plus")
                    ])),
                    _: 1,
                    __: [0]
                  }),
                  _cache[1] || (_cache[1] = _createTextVNode(" Hinzufügen "))
                ]),
                _: 1,
                __: [1]
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_v_btn, {
            disabled: record.value?.feedbacks.length == 0 || _unref(StatePermission)[record.value.state] == 1,
            onClick: openPopup
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { start: "" }, {
                default: _withCtx(() => _cache[2] || (_cache[2] = [
                  _createTextVNode("mdi-arrow-right-bold-box")
                ])),
                _: 1,
                __: [2]
              }),
              _cache[3] || (_cache[3] = _createTextVNode(" Aufgabe beenden "))
            ]),
            _: 1,
            __: [3]
          }, 8, ["disabled"])
        ])
      ]),
      _createVNode(UniversalPopup, {
        ref_key: "closeFeedbackPopup",
        ref: closeFeedbackPopup
      }, null, 512),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "mt-4" }, null, -1)),
      _createVNode(_component_v_expansion_panels, { variant: "popout" }, {
        default: _withCtx(() => [
          _createVNode(_TransitionGroup, { name: "fade-feedback" }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(panels, (panel, index) => {
                return (_openBlock(), _createBlock(_component_v_expansion_panel, { key: index }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_expansion_panel_title, { class: "d-flex" }, {
                      default: _withCtx(() => [
                        _createElementVNode("span", null, "Rückmeldung " + _toDisplayString(panels.findIndex(fb => fb.id === panel.id) + 1), 1),
                        _createVNode(_component_v_spacer)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_v_expansion_panel_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_container, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_textarea, {
                                      modelValue: panel.text,
                                      "onUpdate:modelValue": ($event: any) => ((panel.text) = $event),
                                      label: "Rückmeldung",
                                      variant: _unref(useGlobalSetting)().globalTextVariant,
                                      disabled: isDisabled(panel),
                                      counter: "500",
                                      maxLength: "500"
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "variant", "disabled"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "4" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      modelValue: panel.author,
                                      "onUpdate:modelValue": ($event: any) => ((panel.author) = $event),
                                      disabled: true,
                                      label: "Author",
                                      variant: _unref(useGlobalSetting)().globalTextVariant
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "variant"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, { cols: "4" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      "model-value": (new Date(panel.created_at)).toLocaleString('de-DE'),
                                      disabled: true,
                                      label: "Zeitstempel",
                                      variant: _unref(useGlobalSetting)().globalTextVariant
                                    }, null, 8, ["model-value", "variant"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_col, { cols: "4" }, {
                                  default: _withCtx(() => [
                                    _createVNode(TimepickerSmall, {
                                      modelValue: panel.duration,
                                      "onUpdate:modelValue": ($event: any) => ((panel.duration) = $event),
                                      disabled: isDisabled(panel),
                                      required: true
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1,
    __: [4]
  }))
}
}

})